import { Toaster } from "@nu-art/toasting";
import { Second } from "@nu-art/ts-common";
export const ToastKey_ProtocolNavigation = 'protocol-navigation';
export const Toaster_ProtocolNavigation = new Toaster(ToastKey_ProtocolNavigation, 2 * Second);
export const ToastFilter_ProtocolNavigation = (model) => model.key === ToastKey_ProtocolNavigation;
//# sourceMappingURL=toasting.js.map